// Must be imported as the very first line of index.js — restores localStorage
// from the pre-unload snapshot before registrationSlice.js (or anything else)
// reads localStorage.user, so a page refresh doesn't look like a logged-out
// session. See autoLogout.jsx's releaseOnUnload for where the snapshot is taken.
//
// We deliberately do NOT gate this on performance.getEntriesByType('navigation')
// type === 'reload': browsers only classify an F5/reload-button/location.reload()
// trigger that way — an address-bar Enter on the same URL (or other same-tab
// reloads) reports as 'navigate' instead, even though it's the same refresh from
// the user's perspective. The presence of the backup itself is already a
// sufficient signal: sessionStorage is scoped to this exact tab+origin and is
// wiped automatically by the browser on a real tab/window close, so if
// `saReloadBackup` exists at all, this tab provably never closed.
const backupRaw = sessionStorage.getItem('saReloadBackup');

if (backupRaw) {
    try {
        const backup = JSON.parse(backupRaw);
        Object.entries(backup).forEach(([k, v]) => localStorage.setItem(k, v));
        // selectedSellerEmail was never removed from sessionStorage — impersonation
        // state is already intact. Flag AutoLogout to silently re-acquire the
        // backend lock, since the unload handler's DELETE call already fired.
        sessionStorage.setItem('saJustReloaded', '1');
    } catch {
        // corrupt/oversized backup — fall through, behaves like today (no worse)
    }
}
sessionStorage.removeItem('saReloadBackup');
